module.exports = __webpack_public_path__ + "static/7-184c56f778acaaa7fd6d4042131384df.jpg";